/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Merge_UpInputs */

const en_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge the selected Event with the previous Event.`)
};

const fr_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner l'evenement selectionne avec l'evenement precedent.`)
};

const de_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ausgewählte Ereignis wird mit dem vorherigen Ereignis zusammengeführt.`)
};

const it_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci l'evento selezionato con l'evento precedente.`)
};

const ru_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединить выбранное событие с предыдущим событием.`)
};

const es_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar el evento seleccionado con el evento anterior.`)
};

const zh_cn2_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将选定的事件与之前的事件合并。`)
};

const ja_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを前のイベントと結合します。`)
};

const hi_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट को पिछले इवेंट के साथ मर्ज करें।`)
};

const pt_pt2_shortcut_keys_desc_merge_up = /** @type {(inputs: Shortcut_Keys_Desc_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar o evento selecionado com o evento anterior.`)
};

/**
* | output |
* | --- |
* | "Merge the selected Event with the previous Event." |
*
* @param {Shortcut_Keys_Desc_Merge_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_merge_up = /** @type {((inputs?: Shortcut_Keys_Desc_Merge_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Merge_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_merge_up(inputs)
	if (locale === "de") return de_shortcut_keys_desc_merge_up(inputs)
	if (locale === "it") return it_shortcut_keys_desc_merge_up(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_merge_up(inputs)
	if (locale === "es") return es_shortcut_keys_desc_merge_up(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_merge_up(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_merge_up(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_merge_up(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_merge_up(inputs)
	return en_shortcut_keys_desc_merge_up(inputs)
});